import spinDoor from "../assets/images/spinDoor.png";
import cover from "../assets/images/cover.png";
import pulsator from "../assets/images/pulsators.png";
import stands from "../assets/images/stands.png";
import capacitor from "../assets/images/capacitor.png";
import VegetableFruitBasket from "../assets/images/VegetableFruitBasket.png";
import freshener from "../assets/images/freshener.png";
import VegetableFruitBasketCover from "../assets/images/VegetableFruitBasketCover.png";
import frezerDoor from "../assets/images/freezerDoor.png";
import chillerTray from "../assets/images/ChillerTray.jpg";
import filters from "../assets/images/filters.png";
import bottleShelf from "../assets/images/BottleShelf.png";
import acSpare from "../assets/images/acSpare.jpg";
import stabiliser from "../assets/images/stabiliser.png";
import acStabiliser from "../assets/images/ACStabilisers.png";
import pipes from "../assets/images/pipes.png";
import kettles from "../assets/images/kettle.png";
import spinCap from "../assets/images/spinCap.png";
import defrostTray from "../assets/images/defrostTray.png";
import washingMachineCleaner from "../assets/images/B0DJHC1JQT.jpg";
import washingMachineAccessories from "../assets/images/accessories.png";
import iceCubeTrays from "../assets/images/IceTrays.png";
import shelfCaps from "../assets/images/Shelves.png";
import others from "../assets/images/Others.png";
import wmOthers from "../assets/images/WMOthers.png";
import wmStands from "../assets/images/WashingMachineStand.png";

const categories = [
  { id: 1, name: "Spin Doors", image: spinDoor },
  { id: 2, name: "Refrigerator Cover", image: cover },
  { id: 3, name: "Pulsators", image: pulsator },
  { id: 4, name: "Stands", image: stands },
  { id: 5, name: "Capacitors", image: capacitor },
  { id: 6, name: "Vegetable Fruit Basket", image: VegetableFruitBasket },
  { id: 7, name: "Freshners", image: freshener },
  { id: 8, name: "Vegetable Fruit Basket Cover", image: VegetableFruitBasketCover },
  { id: 9, name: "Freezer doors", image: frezerDoor },
  { id: 10, name: "Filters", image: filters },
  { id: 11, name: "Chiller Trays", image: chillerTray },
  { id: 12, name: "Bottle Shelfs", image: bottleShelf },
  { id: 13, name: "AC Spare", image: acSpare },
  { id: 14, name: "Refrigerator Stabiliser", image: stabiliser },
  { id: 15, name: "Pipes", image: pipes },
  { id: 16, name: "Electric Kettles", image: kettles },
  { id: 17, name: "Spin Caps", image: spinCap },
  { id: 18, name: "Defrost Trays", image: defrostTray },
  { id: 19, name: "Washing Machine Cleaner", image: washingMachineCleaner },
  { id: 20, name: "Accessories", image: washingMachineAccessories },
  { id: 21, name: "Ice Cube Trays", image: iceCubeTrays },
  { id: 22, name: "Shelves", image: shelfCaps },
  { id: 23, name: "Others", image: others },
  { id: 24, name: "AC Stabilisers", image: acStabiliser },
  { id: 25, name: "Washing Machine Others", image: wmOthers },
  { id: 26, name: "Washing Machine Stands", image: wmStands },
];

export default categories;
